import React, {useRef} from 'react';
import {Editor} from '@tinymce/tinymce-react';
import {Button, Typography} from "antd";
import {pdfApi} from "../config";

const {Title} = Typography;
export const PrintPDF = (props) => {
    const html = (props.html || "")
    const fileName = (props.fileName || "")
    const editorRef = useRef(null);
    const log = () => {
            if (editorRef.current) {
                fetch(pdfApi, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        html: editorRef.current.getContent(),
                        pdf: {
                            margin: {
                                top: '25mm',
                                bottom: '25mm',
                                left: '32mm',
                                right: '32mm',
                            },
                            scale: 1
                        },
                        waitFor: 1,
                        goto: {
                            waitUntil: 'load',
                            timeout: 1,
                        }
                    })
                }).then(res => res.blob())
                    .then(data => {
                        const blobUrl = window.URL.createObjectURL(data);
                        const a = document.createElement('a');
                        a.download = fileName;
                        a.href = blobUrl;
                        a.click();
                    })
            }
        }
    ;
    return (<>
        <Title level={5}>PDF 预览</Title>
        <Editor
            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
            initialValue={html}
            onInit={(evt, editor) => editorRef.current = editor}
            apiKey="w6jh4pihm9usrx5t0ob224jieor3bp84yea3whnqcnfcyry1"
            init={{
                promotion: false,
                branding: false,
                language: 'zh-Hans',
                min_height: 500,
                plugins: 'preview searchreplace autolink directionality visualblocks visualchars fullscreen image link template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave autoresize formatpainter',
                toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs',
                fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
            }}
        />
        <div style={{padding: '10px'}}></div>
        <Button type={'primary'} onClick={log}>保存PDF</Button>
    </>)
}
